<template>
    <div class="col-12 d-flex dashboard">
        <div class="w-100">
            <div class="row">
                <AULSCard :aulsValue="allData.auls" />
                <AALSCard :aalsValue="allData.aals" />
                <AVLSCard :avlsValue="allData.avls" />
                <ULTVCard :ultvValue="allData.ultv" />
                <ALVTCards :altvValue="allData.altv" />
                <VLTVCard :vltvValue="allData.vltv" />
                <UACCard :uacValue="allData.uac" />
                <AACCard :aacValue="allData.aac" />
                <VACCard :vacValue="allData.vac" />
            </div>
        </div>
    </div>
</template>

<script>
import AULSCard from './AULSCard.vue'
import AALSCard from './AALSCard.vue'
import AVLSCard from './AVLSCard.vue'
import ULTVCard from './ULTVCard.vue'
import ALVTCards from './ALVTCards.vue'
import VLTVCard from './VLTVCard.vue'
import UACCard from './UACCard.vue'
import AACCard from './AACCard.vue'
import VACCard from './VACCard.vue'

export default {
    name: 'MarketingDashboard',
    components: {
        AULSCard,
        AALSCard,
        AVLSCard,
        ULTVCard,
        ALVTCards,
        VLTVCard,
        UACCard,
        AACCard,
        VACCard
    },
    data: () => ({
        url: '/admin/dashboard/getFinanceMarketing',
        allData: []
    }),
    async created() {
       const res = await axios.get(this.url)
       this.allData = res.data
    }
}
</script>
